/* eslint-disable-next-line no-undef */
const isMobileDevice = () => /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(navigator.userAgent);
const isApplePayAvailable = () => !!window?.ApplePaySession && !!window?.ApplePaySession.canMakePayments();
const isAppleDevice = () => /(Mac|iPhone|iPod|iPad)/i.test(window?.navigator.userAgent)

export {
	isMobileDevice,
	isApplePayAvailable,
	isAppleDevice,
};